import { render, staticRenderFns } from "./vue-plain-pagination.vue?vue&type=template&id=7614a64d&"
import script from "./vue-plain-pagination.vue?vue&type=script&lang=js&"
export * from "./vue-plain-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports